import { render, staticRenderFns } from "./DefaultSettingsSettingsTab.vue?vue&type=template&id=5d89983f&scoped=true"
import script from "./DefaultSettingsSettingsTab.vue?vue&type=script&lang=js"
export * from "./DefaultSettingsSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d89983f",
  null
  
)

export default component.exports